<template>
  <span></span>
</template>

<script>
export default {
  name: 'CreateCutting',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
};
</script>
<style lang="scss"></style>
